export const LOGS_LIST_LOADING = "LOGS_LIST_LOADING";
export const GET_LOGS_LIST = "GET_LOGS_LIST";
export const GET_LOGS_LIST_ERROR = "GET_LOGS_LIST_ERROR";
export const GET_LOGS_BY_ID_LOADING = "GET_LOGS_BY_ID_LOADING";
export const GET_LOGS_BY_ID_SUCCESS = "GET_LOGS_BY_ID_SUCCESS";
export const GET_LOGS_BY_ID_ERROR = "GET_LOGS_BY_ID_ERROR";
